import React from "react";
import ModalBasic from "../../../../components/modal/ModalBasic";
import FormDetail from "../../Form/FormDetail";

export default function ModalDetailPc({
	getFieldValue,
	isOpenFormItem,
	setIsOpenFormItem,
	dataDetailItem,
	handleManagerDataItem,
}) {
	return (
		<div>
			<ModalBasic
				id={"ModalDetailPc-edit"}
				title={"Chi theo sổ quỹ"}
				open={isOpenFormItem === "edit" ? true : false}
				onCancel={() => {
					setIsOpenFormItem(false);
				}}
				footer={null}
				handleManager={(data) => {
					handleManagerDataItem({
						...dataDetailItem,
						...data,
					});
					setIsOpenFormItem(false);
				}}
				data={{
					...dataDetailItem,
					customer_data:
						(dataDetailItem.ten_kh || "") +
						" - " +
						(dataDetailItem.ma_kh || ""),
				}}
				width={"450px"}
				styleBodyForm={{ paddingTop: "0" }}
				labelAlign="left"
			>
				<FormDetail pc1={true} getFieldValueAll={getFieldValue}/>
			</ModalBasic>

			<ModalBasic
				id={"ModalDetailPc"}
				title={"Chi theo sổ quỹ"}
				open={isOpenFormItem === "create" ? true : false}
				onCancel={() => {
					setIsOpenFormItem(false);
				}}
				footer={null}
				handleManager={(data) => {
					handleManagerDataItem({
						...data,
					});
					setIsOpenFormItem(false);
				}}
				width={"450px"}
				styleBodyForm={{ paddingTop: "0" }}
				labelAlign="left"
				data={{
					tien_nt: 0,
					customer_data:
						(getFieldValue("ten_kh") || "") +
						" - " +
						(getFieldValue("ma_kh") || ""),
					ten_kh: getFieldValue("ten_kh"),
					ma_kh: getFieldValue("ma_kh"),
					tk_no: "131",
					ten_tk_no: "Phải thu khách hàng",
				}}
			>
				<FormDetail pc1={true} getFieldValueAll={getFieldValue}/>
			</ModalBasic>
		</div>
	);
}
